import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const accountingStatusesAdapter = getAdapter({ idFieldName: 'value' });

const accountingStatusesSlice = createSlice({
  name: 'accountingStatuses',
  initialState: accountingStatusesAdapter.getInitialState(),
  reducers: {
    setAccountingStatuses: (state, { payload: { accountingStatuses } }) => {
      accountingStatusesAdapter.setAll(state, accountingStatuses);
    },
  },
});

const selectors = accountingStatusesAdapter.getSelectors(({ accountingStatuses }) => accountingStatuses);

export const getAccountingStatuses = (state) => selectors.selectAll(state);

export const {
  setAccountingStatuses,
} = accountingStatusesSlice.actions;

export default accountingStatusesSlice.reducer;